import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export function Services() {
  const services = [
    {
      title: 'Vehicle Wraps & Graphics',
      description:
        'Transform your fleet into mobile billboards with premium vehicle wraps and graphics that showcase your brand throughout Arlington and DFW.',
      icon: 'ri-car-line',
      gradient: 'from-teal-500 to-cyan-500',
      stat: '5–7 yr lifespan',
    },
    {
      title: 'Storefront & Channel Letters',
      description:
        'Make a lasting first impression with illuminated channel letters and professional storefront signage that attracts customers 24/7.',
      icon: 'ri-store-2-line',
      gradient: 'from-orange-500 to-red-500',
      stat: '24/7 visibility',
    },
    {
      title: 'Banners & Displays',
      description:
        'Versatile indoor and outdoor banners for promotions, events, and campaigns with vibrant colors and durable weather-resistant materials.',
      icon: 'ri-flag-line',
      gradient: 'from-emerald-500 to-teal-600',
      stat: 'Same-week turnaround',
    },
    {
      title: 'Trade Show & Exhibit Graphics',
      description:
        'Stand out at your next trade show with professional displays, backdrops, and promotional materials that draw crowds to your booth.',
      icon: 'ri-presentation-line',
      gradient: 'from-amber-500 to-orange-500',
      stat: 'Portable & reusable',
    },
    {
      title: 'Decals & Promotional Materials',
      description:
        'Custom decals, window graphics, floor wraps, and promotional signage to reinforce your brand at every customer touchpoint.',
      icon: 'ri-price-tag-3-line',
      gradient: 'from-rose-500 to-orange-400',
      stat: 'Indoor & outdoor',
    },
    {
      title: 'Wayfinding & Directional Signs',
      description:
        'Guide visitors through your facility with ADA-compliant wayfinding systems that enhance user experience and reinforce brand identity.',
      icon: 'ri-direction-line',
      gradient: 'from-teal-600 to-emerald-500',
      stat: 'ADA compliant',
    },
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-4"
        >
          <span className="text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3 block">
            Custom Signage Arlington TX
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-orange-500">
              Services
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-6">
            Comprehensive custom signage solutions for Arlington businesses — designed,
            produced, and installed under one roof.
          </p>
          <Link
            to="/services"
            className="inline-flex items-center space-x-2 text-teal-600 font-semibold text-sm hover:text-teal-700 transition-colors cursor-pointer"
          >
            <span>Explore All Services</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.08 }}
              className="group bg-white rounded-2xl p-8 hover:shadow-xl transition-all border border-gray-100 hover:border-teal-100 cursor-pointer"
            >
              <div
                className={`w-14 h-14 bg-gradient-to-br ${service.gradient} rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}
              >
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-bold text-gray-900">{service.title}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{service.description}</p>
              <div className="flex items-center space-x-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-sm"></i>
                </div>
                <span className="text-teal-600 text-xs font-semibold">{service.stat}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-12 text-center"
        >
          <button
            onClick={() => {
              const el = document.getElementById('quote-form') || document.getElementById('get-quote');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold rounded-full hover:from-orange-600 hover:to-orange-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-text-line"></i>
            <span>Get a Free Quote Today</span>
          </button>
          <p className="text-gray-500 text-xs mt-3">
            Fast response · No obligation · Serving all of DFW
          </p>
        </motion.div>
      </div>
    </section>
  );
}
